import {MutableRefObject, useEffect, useState} from 'react';
import {pushToDataLayer} from '~/CreateFabricGreetingCard/utils/dataTracking';
import {selectUserOrSystemDisabled} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {useAppSelector} from '~/QuickEcards/store';
import {StepConfig} from '~/QuickEcards/types/misc';

interface TrackRouteChangesProps {
  currentRoute: StepConfig | null;
  pageContainer?: MutableRefObject<HTMLDivElement>;
}

export const useTrackRouteChanges = ({currentRoute, pageContainer}: TrackRouteChangesProps) => {
  const [previouslyTrackedRoutes, setPreviouslyTrackedRoutes] = useState<string[]>([]);
  const giftCardAttached = !useAppSelector(selectUserOrSystemDisabled) ? 1 : 0;

  useEffect(() => {
    if (!currentRoute?.name) return;

    const sections = document.getElementsByClassName('quick-ecards__page');

    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
    }

    const activeSection = document.getElementById(currentRoute.name);
    if (activeSection && pageContainer?.current) {
      activeSection.classList.add('active');
      pageContainer.current.scrollTop = activeSection.offsetTop - 120;
    }

    if (!currentRoute?.trackingLabel) return;

    if (
      previouslyTrackedRoutes[previouslyTrackedRoutes.length - 1] !== currentRoute.trackingLabel
    ) {
      setPreviouslyTrackedRoutes((prevState) => {
        if (currentRoute.trackingLabel) return [...prevState, currentRoute.trackingLabel];
        return prevState;
      });
      pushToDataLayer(currentRoute.trackingLabel, true, currentRoute?.trackEGift, giftCardAttached);
    }
  }, [pageContainer, previouslyTrackedRoutes, giftCardAttached, currentRoute]);
};
